import {
  PRODUCER,
} from '../actions/constants';

const initialState = {
  handling: false,
  data: {},
};

export default function producer(state = initialState, action) {
  switch (action.type) {
    case PRODUCER.handlers.fetch:
    case PRODUCER.handlers.update:
    case PRODUCER.handlers.import:
    case PRODUCER.handlers.remove:
      return {
        ...state,
        handling: true,
      };
    case PRODUCER.update:
      return {
        ...state,
        data: action.merge ? {
          ...state.data,
          ...action.data,
        } : action.data,
        handling: false,
      };
    default:
      return state;
  }
}
